export default __webpack_public_path__ + "static/valve_w.d1605e6937ff08b22b786746bd35d6ec.png";